import { useState } from "react";

export default function BrotherImage({ src, name, position = "center", className = "" }) {
  const [errored, setErrored] = useState(false);

  if (src && !errored) {
    return (
      <img
        src={src}
        alt={name}
        onError={() => setErrored(true)}
        style={{ objectPosition: position }}
        className={`w-full h-full object-cover ${className}`}
      />
    );
  }

  const initials = name
    .replace(/^(Fr\.|Br\.)\s*/i, "")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");
  return (
    <div className={`w-full h-full flex flex-col items-center justify-center bg-brand-green text-brand-bg ${className}`}>
      <span className="font-serif text-6xl">{initials}</span>
      <span className="mt-2 text-xs uppercase tracking-[0.2em] text-brand-sand">Josephian Brother</span>
    </div>
  );
}
